<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_22583_33794)">
      <path
        d="M12.0004 20.9995C11.8688 21.0003 11.7383 20.9751 11.6165 20.9253C11.4946 20.8755 11.3838 20.8022 11.2904 20.7095L3.52036 12.9295C2.54572 11.9447 1.99902 10.6151 1.99902 9.22953C1.99902 7.84396 2.54572 6.51435 3.52036 5.52953C4.50262 4.55004 5.83319 4 7.22036 4C8.60753 4 9.9381 4.55004 10.9204 5.52953L12.0004 6.60953L13.0804 5.52953C14.0626 4.55004 15.3932 4 16.7804 4C18.1675 4 19.4981 4.55004 20.4804 5.52953C21.455 6.51435 22.0017 7.84396 22.0017 9.22953C22.0017 10.6151 21.455 11.9447 20.4804 12.9295L12.7104 20.7095C12.6169 20.8022 12.5061 20.8755 12.3843 20.9253C12.2624 20.9751 12.132 21.0003 12.0004 20.9995Z"
        fill="#F08B71"
      />
    </g>
    <defs>
      <clipPath id="clip0_22583_33794">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0 -0.000488281)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
